import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import { games, categories } from '@/mocks/games';

export default function Categories() {
  const [activeCategory, setActiveCategory] = useState('all');

  useDocumentMeta(
    '游戏大厅 - 九游娱乐',
    '九游娱乐游戏大厅汇聚2000+精品游戏，涵盖棋牌、电子游艺、捕鱼、体育竞猜、真人视讯等丰富品类。安全、流畅、公平的游戏体验，立即加入畅玩。'
  );

  const filteredGames = activeCategory === 'all'
    ? games
    : games.filter((g) => g.category === activeCategory);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="pt-24 pb-10 bg-background-100">
            <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
              <Breadcrumb items={[{ label: '游戏大厅' }]} />
              <div className="mt-6 mb-2">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-3">
                  <i className="ri-gamepad-line"></i>
                  游戏大厅
                </div>
                <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
                  探索精彩游戏世界
                </h1>
                <p className="text-foreground-600 text-sm md:text-base max-w-xl">
                  九游娱乐汇聚2000+精品游戏，涵盖多个品类。无论您喜欢策略棋牌、刺激老虎机还是真人互动，这里都能满足您。
                </p>
              </div>
            </div>
          </section>

          <section className="w-full py-10 bg-background-50">
            <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
              <div className="flex items-center flex-wrap gap-2 mb-8">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setActiveCategory(cat.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                      activeCategory === cat.id
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                    {cat.name}
                  </button>
                ))}
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {filteredGames.map((game) => (
                  <Link
                    key={game.id}
                    to={`/category/${game.category}`}
                    className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300"
                  >
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img
                        src={game.image}
                        alt={game.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                        {game.isHot && (
                          <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">热门</span>
                        )}
                        {game.isNew && (
                          <span className="px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-semibold">新游</span>
                        )}
                      </div>
                    </div>
                    <div className="p-4">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                          {game.name}
                        </h3>
                        <span className="flex items-center gap-1 text-xs text-accent-600">
                          <i className="ri-star-fill text-xs"></i>
                          {game.rating}
                        </span>
                      </div>
                      <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                        {game.description}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-foreground-500">
                          <i className="ri-user-line mr-1"></i>
                          {game.players}玩家
                        </span>
                        <div className="flex flex-wrap gap-1">
                          {game.tags.map((tag) => (
                            <span key={tag} className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">
                              {tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              {filteredGames.length === 0 && (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-100">
                    <i className="ri-gamepad-line text-3xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无游戏</p>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}